// angular import
import { ChangeDetectorRef, Component, ElementRef, HostListener, inject, input, OnInit, output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgFor, SlicePipe } from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
// project import

// icon
import { IconService, IconDirective } from '@ant-design/icons-angular';
import {
  BellOutline,
  SettingOutline,
  GiftOutline,
  MessageOutline,
  PhoneOutline,
  CheckCircleOutline,
  LogoutOutline,
  EditOutline,
  UserOutline,
  ProfileOutline,
  WalletOutline,
  QuestionCircleOutline,
  LockOutline,
  CommentOutline,
  UnorderedListOutline,
  ArrowRightOutline,
  GithubOutline,
  SwapLeftOutline,
  BarChartOutline,
  FireOutline,
} from '@ant-design/icons-angular/icons';
import { NgbDropdown, NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import Swal from 'sweetalert2';
import { Api } from 'src/app/services/api';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { Messagedetails } from 'src/app/demo/component/messagedetails/messagedetails';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Settings } from 'src/app/demo/component/utilities/settings/settings';
import { TimeOffComponent } from 'src/app/demo/fase_dos/components/time-off/time-off';
import { CheckinComponent } from 'src/app/demo/fase_dos/components/modal/checkin.component/checkin.component';
import { Overtime } from 'src/app/demo/fase_dos/components/overtime/overtime';
@Component({
  selector: 'app-nav-right',
  imports: [IconDirective, MatDialogModule,RouterModule, NgScrollbarModule,
    MatButtonModule, NgbNavModule, NgbDropdownModule, CommonModule,
     SlicePipe,],
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss']
})
export class NavRightComponent implements OnInit {
  private iconService = inject(IconService);
  usuario = localStorage.getItem('nombre') || 'John';
  apellidop = localStorage.getItem('apellido') || 'Doe';
  role = localStorage.getItem('rol') || 'Rol';
  swap:boolean = false;
  rolui:string;
  userid = localStorage.getItem('userid') || '1984';
  avatar = localStorage.getItem('avatar') ? `https://myscapa.com/scapapi/${localStorage.getItem('avatar')}` : 'assets/images/default-avatar.jpg';
  notificaciones:any[]=[];
  userImage = this.avatar;
  styleSelectorToggle = input<boolean>();
  Customize = output();
  windowWidth: number;
  screenFull: boolean = true;
  combID:string;
    currentPath: string;
    menuVisibleProfile = false;
    menuVisibleNoti = false;

  constructor(public dialog: MatDialog,private router: Router,private apiservice: Api,
    private sanitizer: DomSanitizer,private cdRef: ChangeDetectorRef,private el: ElementRef) {
    moment().locale('es');
    this.windowWidth = window.innerWidth;
    this.iconService.addIcon(
      ...[
        CheckCircleOutline,
        GiftOutline,
        MessageOutline,
        SettingOutline,
        PhoneOutline,
        LogoutOutline,
        UserOutline,
        EditOutline,
        ProfileOutline,
        QuestionCircleOutline,
        LockOutline,
        CommentOutline,
        UnorderedListOutline,
        ArrowRightOutline,
        BellOutline,
        GithubOutline,
        WalletOutline, SwapLeftOutline,
        BarChartOutline,
        FireOutline
      ]
    );

        // this.setting = this.role == 'Teacher' ||  this.role  == 'diraca' || this.role == 'Texp' || this.role == 'Assmt' ? this.setting.filter(item => item.title !== 'Alertas'  && item.title !== 'Metricas' ) : this.setting;
        const restrictedRoles = ['Teacher', 'diraca', 'Texp', 'Assmt', 'Ventas'];

if (restrictedRoles.includes(this.role)) {
  this.setting = this.setting.filter(
    item => !['Alertas', 'Metricas'].includes(item.title)
  );
}
  this.router.events.subscribe(() => (this.menuVisibleProfile = false, this.menuVisibleNoti = false));

  }
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const clickedInside = this.el.nativeElement.contains(event.target);
  if (!clickedInside) {
    this.menuVisibleProfile = false;
    this.menuVisibleNoti = false; // Only close if clicked outside this component
  }
}
  profile = [
    {
      icon: 'assignment_ind',
      title: 'Editar Perfil',
      url: '/newuser',
      action: false,
      visible:true
    },{
      icon: 'edit_location',
      title: 'Check-in',
      url: '/checkin',
      action: false,
      visible: true
    },
    {
      icon: 'more_time',
      title: 'Overtime',
      url: '/overtime',
      action: false,
      visible:true
    },
    {
      icon: 'airline_seat_individual_suite',
      title: 'Time Off',
      url: '/timeoff',
      action: false,
      visible:true
    },
    {
      icon: 'power_settings_new',
      title: 'Logout',
      url: '/login',
      action:'logout',
      visible:true
    }
  ];

  setting = [
    {
      icon: 'question-circle',
      title: 'Soporte',
      action: false

    },
    {
      icon: 'user',
      title: 'Cuenta',
      url: '/newuser',
      action: false
    }, {
      icon: 'message',
      title: 'Alertas',
      url: '/alertas',
      action: false
    },
    {
      icon: 'bar-chart',
      title: 'Metricas',
      url: '/logs',
      action: false
    }

  ];
  ngOnInit(): void {
    this.screenFull = document.fullscreenElement ? true : false;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
// console.log(this.iconService.getRenderedContent)
this.checar_celebraciones().then((celebraciones)=>{
  //  console.log('celebraciones',celebraciones)
  let UserRol = localStorage.getItem('rol');
 this.getAssignation().then((notify)=>{
  // console.log('notify',notify)
      if(notify.length > 0){
      notify.forEach((evento:any)=>{
                let timObj = moment(evento.creado, 'YYYY-MM-DD HH:mm:ss').format('MMM DD');
                let dateObj = moment(evento.creado, 'YYYY-MM-DD HH:mm:ss').calendar();
                let towork = evento.comp_id.slice(-1);
                let tipo;
              evento.tipo == 'caldata'? tipo = 'Asignación' : tipo = evento.tipo;
              let icono = 'message';
              if(evento.tipo == 'caldata'){ icono = 'event';}
              if(evento.tipo == 'Faltas'){icono = 'face_6';evento.nombre = 'Faltas';}
               if(evento.tipo == 'Request'){icono = 'beach_access';evento.nombre = 'Time off';}
              if(evento.message && evento.message.toLowerCase().includes('falta grave:')){icono = 'report_problem';evento.nombre = 'Faltas Graves';}
            evento.Mmessage = evento.message;
            evento.sent = dateObj;
            evento.time = timObj;
            evento.towork = towork == "C" ? "caldata" : "messages";
            evento.summary = this.sanitizer.bypassSecurityTrustHtml(`${evento.nombre}, ${evento.message ? evento.message?.slice(0,55) : ''}...`);
            evento.tipo = tipo;
            evento.icono = icono;
            evento.from = evento.from != "0" ? evento.from : '';
            evento.assby = evento.assby != "0" ? evento.assby : '';
            evento.sucname = evento.sucname != "0" ? evento.sucname : '';


              });
                if(UserRol == 'Administrador' || UserRol == 'SysAdmin' ){
                this.notificaciones = [
                  ...(notify || []),
                  ...((Array.isArray(celebraciones) ? celebraciones : []))
                ];                }else{
                this.notificaciones = notify;
                }
this.notificaciones.sort((a, b) => moment(b.creado).valueOf() - moment(a.creado).valueOf());
 this.apiservice.setNotificaciones(this.notificaciones);
        // console.log(this.notificaciones);
        this.apiservice.notificaciones$.subscribe(list => {
          // console.log('subscribe ',list)
    this.notificaciones = list;
  });
      }
    });
});

    switch(this.role ){
      case 'Texp':
      this.rolui = 'Training Expert';
      this.swap = true;
      break;
     case 'Assmt':
      this.rolui = 'Assessment Manage';
      this.swap = true;
      break;
    case 'diraca':
      this.rolui = 'Director Académico';
      this.swap = true;
      break;
      default:
      this.rolui = this.role;
      this.swap = false;
      break;
    }


  }
cleanLocal(){
  // console.log('logout and clear')
  localStorage.removeItem('access_token');
  localStorage.removeItem('userid');
  localStorage.removeItem('suscursal');
  localStorage.removeItem('rol');
  localStorage.removeItem('nombre');
  localStorage.removeItem('avatar');
  localStorage.removeItem('apellido');
  localStorage.removeItem('teachID');
  localStorage.removeItem('swap');
  localStorage.removeItem('celebra');
  localStorage.removeItem('sensible');
  localStorage.removeItem('permissions');

}
  GoTo(goto): void {
    // console.log('a donde ', goto)
    if(goto === '/login') {
      //localStorage.clear(); // Clear user data from local storage
      this.cleanLocal();
      this.router.navigate(['/login']); // Redirect to the login page
      return;
    }else if(goto === '/newuser') {
      if(this.userid == '1984') {
        this.showMessageWithAnimation('No hay usuario Logeado', 'error');
        return;
      }
        // If userid exists, navigate to edit mode
       this.router.navigate(['/newuser'], {
  queryParams: {
    mode: 'edit',
    id: this.userid,
    }
 });    }else if(goto === '/alertas') {
      //localStorage.clear(); // Clear user data from local storage
      this.opensettings();
      return;
    }else if(goto === '/timeoff') {
      //localStorage.clear(); // Clear user data from local storage
      this.openTimeOffModal();
      return;
    }else if(goto === '/checkin') {
      //localStorage.clear(); // Clear user data from local storage
      this.opencheckinModal();
      return;
    }else if(goto == '/overtime'){
            this.openOvertimeModal();
    }else {
      this.router.navigate([`/${goto}`]); // Redirect to the specified route
    }

  }

    // Message system
    showMessageWithAnimation(text: string, type: 'success' | 'error' | 'warning' | 'info'): void {
      let messageText = text;
      let messageType = type;
      let showMessage = true;
  Swal.fire({
    title: "Notificación",
    text: messageText,
    icon: messageType,
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: false,
  });
    }

      async getAssignation(): Promise<any> {
  // `modalidad = 'Online' AND sucid = ${this.filtroTables }`
  let UserRol = localStorage.getItem('rol');
  let mifultro = ``;
  let filtrofaltas = '';
  let teacherid=0;

  // this.apiservice.roleListTeacher

    if(this.apiservice.roleListTeacher.includes(UserRol)){
  // if(UserRol == 'Teacher'){
  teacherid = parseInt(localStorage.getItem('teachID') || '0');
  teacherid = isNaN(teacherid) ? 0 : teacherid;

  // mifultro = teacherid > 0 ? `FIND_IN_SET('${teacherid}', messages_view.TeacherId) AND messages_view.new = 1 ;` : '';
 mifultro = teacherid > 0 ? ` (FIND_IN_SET('${teacherid}', messages_view.TeacherId) AND messages_view.new = 1) OR (FIND_IN_SET('${teacherid}', messages_view.to_user) AND messages_view.new = 1)` : '';

  }else{
      let usuario = parseInt(localStorage.getItem('userid') || '0');
  mifultro = usuario > 0 ? ` (FIND_IN_SET('${usuario}', messages_view.to_user) AND messages_view.new = 1) OR (FIND_IN_SET('${usuario}', messages_view.assignees) AND messages_view.new = 1)OR (tipo = 'Freshman' AND messages_view.new = 1)` : '';

  }
  if(UserRol == 'Administrador'){
    let sucursales = localStorage.getItem('suscursal');
   let { clause, params, debugClause }= this.buildSucursalFilter(sucursales);

  mifultro += ` OR ${clause}`;
  }
            // console.log('assingations mifultro ', mifultro);

  return new Promise((resolve, reject) => {
    this.apiservice.getForTable('messages_view', mifultro)
      .subscribe({
        next: (assignations: any[]) => {
          // console.log('assingations ', assignations);
          if (!assignations || assignations.length === 0) {
            return resolve(false);
          }


           // <- force Angular to refresh the view
          resolve(assignations)
        },
        error:(error)=>{
      return reject(error);
        }
      });
});
}
checar_celebraciones(): Promise<any>{
  return new Promise((resolve, reject) => {
    this.apiservice.getForTable('upcoming_celebrations', false)
      .subscribe({
        next: (celebraciones: any[]) => {
          //  console.log('celebraciones ', celebraciones);
          if (!celebraciones || celebraciones.length === 0) {
            return resolve(false);
          }
          // 🔥 REMOVE items with anniversary_status not null
        celebraciones = celebraciones.filter(ev => ev.anniversary_status === null);
  let micumpleoany = localStorage.getItem('userid');
  if(celebraciones.length > 0){
      celebraciones.forEach((evento:any)=>{
                let timObj = '';
                let dateObj = '';
                let tipo;
             if (evento?.birthday_status && evento?.birthday_status?.toLowerCase().includes('cumpleaños')) {
                tipo = 'Cumpleaños';
              } else if (evento?.anniversary_status && evento?.anniversary_status?.toLowerCase().includes('hoy')) {
                tipo = 'Aniversario';
              }else{
                tipo = 'Celebración';
              }
             evento.tipo = tipo;
              evento.birthday_status = evento.cumple? `${evento.birthday_status || ''}, ${ moment(evento.cumple).format('ll')}.`:'';
              evento.anniversary_status = evento.alta ? `${evento.anniversary_status || ''}, ${moment(evento.alta).format('ll')}.`:'';
            evento.message = `${evento.birthday_status || ''}. ${evento.anniversary_status || ''}`;
            evento.Mmessage = `${evento.birthday_status || ''} ${evento.anniversary_status || ''}`;
            evento.sent = dateObj;
            evento.time = timObj;

              evento.towork = "messages";

              let previewMsg = evento.message ? evento.message.slice(0,55) : '';
            evento.summary = this.sanitizer.bypassSecurityTrustHtml(`${evento.tipo}, ${previewMsg}...`);
            evento.icono = 'celebration';
            evento.from = evento.from != "0" ? evento.from : '';
            evento.assby = evento.assby != "0" ? evento.assby : '';
            evento.sucname = evento.sucname != "0" ? evento.sucname : '';

            if(micumpleoany == evento.id && tipo == 'Cumpleaños' ){

              this.apiservice.setCelebracion('cumple');
               console.log('setCelebracion cumple');

            }
            if(micumpleoany == evento.id && tipo == 'Aniversario' ){
             this.apiservice.setCelebracion('aniv');
                          //  console.log('setCelebracion aniv');

            }

              });
       }
          // console.log('celebraciones ', celebraciones);

           // <- force Angular to refresh the view
          resolve(celebraciones)
        },
        error:(error)=>{
      return reject(error);
        }
      });
});
}
buildSucursalFilter(valuesCsv: string) {
  const values = (valuesCsv || "")
    .split(",")
    .map(v => v.trim())
    .filter(Boolean);

  if (values.length === 0) {
    return { clause: "", params: [], debugClause: "" };
  }

  // Generate placeholders (?, ?, ...)
  const placeholders = values.join(",");

  const clause = `(messages_view.sucursal IN (${placeholders})
                   AND messages_view.tipo='Faltas'
                   AND messages_view.new = 1)`;

  // For logging/debugging only (unsafe for execution!)
  const debugClause = `(messages_view.sucursal IN (${values.join(",")})
                        AND messages_view.tipo='Faltas'
                        AND messages_view.new = 1)`;

  return { clause, params: values, debugClause };
}

    openDialog(message:any): void {
//Cierro menu
this.toggleNoti();
      // Prevent opening duplicates
const isOpen = this.dialog.openDialogs
  .some(dialog => dialog.componentInstance instanceof Messagedetails);

if (isOpen) {
  this.dialog.closeAll(); // Dialog is already open → do NOT open another
}
      const dialogRef = this.dialog.open(Messagedetails, {
        width: '500px',
        panelClass: 'dialog-container',
        data: message,
      });
      let tabletoEdit = message.towork;
      // console.log('update message ', tabletoEdit, ' message.id ', message.id);
      this.apiservice.updateData(tabletoEdit,{new: 0, id:message.id}).subscribe({
    next:(demos)=>{
        //  console.log('udpated  ',  demos);
    },
    error: (error)=>{
      // console.log('error ', error);
    }
  });

      dialogRef.afterClosed().subscribe((result) => {
        // console.log('CErro dialog ', result)
        if (result === 'acknowledge') {
            this.ngOnInit();
        }
      });
    }
  opensettings(): void {
      const dialogRef = this.dialog.open(Settings, {
        width: '500px',
        panelClass: 'dialog-container',
      });

      dialogRef.afterClosed().subscribe((result) => {
        // console.log('CErro dialog ', result)
        if (result === 'acknowledge') {
            // this.ngOnInit();
        }
      });
    }

  swapdashboard(){
  this.currentPath = this.router.url;
    if(this.currentPath  == '/dashboard/default'){
      this.router.navigate(['/dashboard/teacher']);
    }else if(this.currentPath  == '/dashboard/teacher'){
    this.router.navigate(['/dashboard/default']);
    }
  }
 toggleDropdown(drop: NgbDropdown): void {
  // safely toggle Angular state

  if (drop.isOpen()) drop.close();
  else drop.open();
  // ensure Angular detects and applies new state
  this.cdRef.detectChanges();
}

toggleMenu(): void {

  this.menuVisibleNoti = false;
  this.menuVisibleProfile = !this.menuVisibleProfile;
}
toggleNoti(): void {
  this.menuVisibleProfile = false;
  this.menuVisibleNoti = !this.menuVisibleNoti;
}
closeMenu(): void {
  this.menuVisibleProfile = false;
}

openTimeOffModal() {
  this.toggleMenu();
  this.dialog.open(TimeOffComponent, {
    width: '450px',
    data: {
      granted: 12,
      used: 3,
      available: 9,
      history: [
        { date: '08/dic/2025', days: 2, status: 'Aprobado' },
        { date: '15/dic/2025', days: 1, status: 'En revisión' },
        { date: '30/nov/2025', days: 3, status: 'Rechazado' }
      ]
    }
  }).afterClosed().subscribe(res => {
    console.log("RESULT:", res);
  });
}
opencheckinModal() {
  this.toggleMenu();
  this.dialog.open(CheckinComponent, {
    width: '550px',
    height: '500px',
  }).afterClosed().subscribe(res => {
    console.log("RESULT:", res);
  });
}

openOvertimeModal() {
  this.toggleMenu();
      // width: '650px',
  this.dialog.open(Overtime, {

  }).afterClosed().subscribe(res => {
    console.log("RESULT Overtime:", res);
  });
}

setasRead(messid:any, index:any, event: Event){
    event.stopPropagation(); // prevents openDialog
  event.preventDefault();  // optional (since inside <a>)
    let q =``;

  if (messid.comp_id?.endsWith('M')) {
  q = `UPDATE messages SET new = 0 WHERE id = ${messid.id}`;
}else  if (messid.comp_id?.endsWith('C')){
    q = `UPDATE caldata SET new = 0 WHERE id = ${messid.id}`;
}
  console.log('mark as read ', messid, index, q);
this.notificaciones.splice(index, 1);
this.apiservice.rawquery('messages', btoa(q)).subscribe({
  next:(res)=>{
    console.log('message marked as read ', res);
  },
  error:(error)=>{
    console.log('error marking message as read ', error);
  }
});
  console.log('test ', q, index);
}
}
